/**
 * 云教材使用统计统计api
 * 云教材统计api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import IdNameVo from '../../statistics/model/IdNameVo';
import PagingAccountProgressVo from '../../statistics/model/PagingAccountProgressVo';
import TextbookStatisticsVo from '../../statistics/model/TextbookStatisticsVo';
  /**
   * TextbookStat service.
   * @module statistics/api/TextbookStatApi
   * @version 0.2.0
   */

  /**
   * Constructs a new TextbookStatApi. 
   * @alias module:statistics/api/TextbookStatApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 班课中各项目学员排名
     * @param {Integer} pageNum 页码
     * @param {String} indicator 排名类别（studyProgress学习进度、studyDuration学习总时长、readingDuration阅读时长、videoDuration视频时长、exercisesAccuracy测试平均正确率、exercisesNum交互练习次数、notesNum笔记条数、hightlightNum高亮条数、maxContinuedTime最长连续学习时长、extendedStudyNum扩展学习次数、threadInitiatedNum发起讨论次数、threadJoinedNum参与讨论次数）
     * @param {Integer} id 教材id
     * @param {Integer} dingOrgId dingOrgId
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.unitId 单元id
     * @param {Integer} opts.lessonId 节id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:statistics/model/PagingAccountProgressVo}
     */
this.getStudentsRanking = function(pageNum, indicator, id, dingOrgId, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling getStudentsRanking";
      }

      // verify the required parameter 'indicator' is set
      if (indicator == undefined || indicator == null) {
        throw "Missing the required parameter 'indicator' when calling getStudentsRanking";
      }

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getStudentsRanking";
      }

      // verify the required parameter 'dingOrgId' is set
      if (dingOrgId == undefined || dingOrgId == null) {
        throw "Missing the required parameter 'dingOrgId' when calling getStudentsRanking";
      }


      var pathParams = {
        'indicator': indicator,
        'id': id
      };
      var queryParams = {
        'pageNum': pageNum,
        'unitId': opts['unitId'],
        'lessonId': opts['lessonId'],
        'dingOrgId': dingOrgId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingAccountProgressVo;
      return this.apiClient.callApi(
        '/api/textbook/stat//{id}/students_ranking/{indicator}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 班级教材使用分章节统计
     * @param {Integer} id 教材id
     * @param {Integer} dingOrgId dingOrgId
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.unitId 单元id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:statistics/model/TextbookStatisticsVo}
     */
this.getTextbookGroupedStat = function(id, dingOrgId, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getTextbookGroupedStat";
      }

      // verify the required parameter 'dingOrgId' is set
      if (dingOrgId == undefined || dingOrgId == null) {
        throw "Missing the required parameter 'dingOrgId' when calling getTextbookGroupedStat";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'unitId': opts['unitId'],
        'dingOrgId': dingOrgId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = TextbookStatisticsVo;
      return this.apiClient.callApi(
        '/api/textbook/stat//{id}/grouped_stat', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 班级教材使用统计
     * @param {Integer} id 教材id
     * @param {Integer} dingOrgId dingOrgId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:statistics/model/TextbookStatisticsVo}
     */
this.getTextbookStat = function(id, dingOrgId) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getTextbookStat";
      }

      // verify the required parameter 'dingOrgId' is set
      if (dingOrgId == undefined || dingOrgId == null) {
        throw "Missing the required parameter 'dingOrgId' when calling getTextbookStat";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'dingOrgId': dingOrgId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = TextbookStatisticsVo;
      return this.apiClient.callApi(
        '/api/textbook/stat//{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 使用教材的钉钉班级列表
     * @param {Integer} id 教材id
     * @param {Integer} companyId 院校id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:statistics/model/IdNameVo>}
     */
this.getUsedDingOrgList = function(id, companyId) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getUsedDingOrgList";
      }

      // verify the required parameter 'companyId' is set
      if (companyId == undefined || companyId == null) {
        throw "Missing the required parameter 'companyId' when calling getUsedDingOrgList";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'companyId': companyId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [IdNameVo];
      return this.apiClient.callApi(
        '/api/textbook/stat//{id}/ding_org_list', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
